import React, { useState, useEffect } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import CardHeader from "../../../Components/CardHeader";
import { faArrowLeft, faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toastSuccess } from "../../../Components/ToastNotification";
import { getDriverGroups } from "../../../services/DriverGroups";

const groupMessageValidator = (value) => {
  let errors = {};
  if (!value["title"]) {
    errors.title = "Message Title is required";
  }
  if (!value["drivers_groups"]) {
    errors.drivers_groups = "Select a driver";
  }
  if (!value["drivers"]) {
    errors.drivers = "manager is required";
  }
  return errors;
};

const headerButtons = [
  {
    buttonTitle: "Back to messages",
    buttonUrl: "../driversgroupmessage",
    icon: faArrowLeft,
  },
];

const INITIAL_DATA = {
  title: "",
  drivers_groups: "",
};

const AddDriverMessage = () => {
  const [data, setData] = useState(INITIAL_DATA);
  const [formErrors, setFormErrors] = useState([]);
  const [groups, setGroups] = useState([]);
  const [selectValue, setSelectedValue] = useState([]);

  useEffect(() => {
    getDriverGroups().then((res) => setGroups(res.data));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setData({ ...data, [name]: value });
    let inputs = {
      ...data,
      [name]: value,
    };
    setFormErrors(groupMessageValidator(inputs));
  };



  const handleSubmit = (e) => {
    e.preventDefault();

    // setFormErrors(Validater(data));
    toastSuccess("Successfully created user");
    // redirect("/");
  };

  return (
    <div className="container-fluid">
      <CardHeader headerItems={headerButtons} title="SEND GROUP MESSAGE" />

      <Card className="mb-3 border-0 shadow-sm rounded-5">
        <Card.Body>
          <div className="form-wrapper">
            <Form
              noValidate
              className="needs-validation"
              onSubmit={handleSubmit}
            >
              <Row className="mb-3">
                <Form.Group as={Col}>
                  <Form.Label htmlFor="text" className="fw-600">
                    Message Title
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="title"
                    placeholder="Message Title"
                    onChange={handleChange}
                    value={data.title}
                    className="border-2"
                    isInvalid={formErrors.title}
                  />
                  {formErrors.title && (
                    <Form.Control.Feedback type="invalid">
                      {formErrors.title}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              </Row>

              <Row className="mb-3">
                <Form.Group as={Col}>
                  <Form.Label className="fw-600"> Drivers group</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    name="drivers_groups"
                    onChange={handleChange}
                    value={data.drivers_groups}
                    isInvalid={formErrors.drivers_groups}
                  >
                    <option>Select group</option>
                    {groups.map((item, idx) => (
                      <option key={idx} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </Form.Select>
                  {formErrors.drivers_groups && (
                    <Form.Control.Feedback type="invalid">
                      {formErrors.drivers_groups}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              </Row>

              <Row className="mb-3">
                <Form.Group as={Col}>
                  <Form.Label className="fw-600">Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="message"
                    placeholder="Message"
                    onChange={handleChange}
                    value={data.address}
                    style={{ height: "300px" }}
                  />
                </Form.Group>
              </Row>

              <Button
                variant="primary"
                type="submit"
                className="shadow rounded-5"
              >
                <FontAwesomeIcon icon={faCircleCheck} /> Send Message
              </Button>
            </Form>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default AddDriverMessage;
